module.exports = __webpack_public_path__ + "img/desaic.a2da8b3c.jpg";